import Swiper from 'swiper/dist/js/swiper.js';
import owd from 'owd/owd';

window.matchMedia('(max-width: 767px)').addListener((e) => {
	if ($('[data-slider="categories"]').length) {
		location.reload();
	}
});

export default class Slider extends owd.Component {
	init() {
		this.count = this.$element.find('.slider-slide').length;
		this.curr = 1;

		this.prepareDom();
		this.createSlider();
		this.bind();
		this.updateBeforeAfterClasses();

	}

	prepareDom() {
		if (!this.$element.find('.swiper-container').length) {
			this.$element.append('<div class="swiper-container"><div class="swiper-wrapper"></div></div>');
			this.$element.find('.swiper-wrapper').append(this.$element.find('.slider-slide'));
			this.$element.find('.slider-slide').addClass('swiper-slide').each((index, item) => {
				$(item).attr('data-slide-number', index);
			});
		}

		this.$swiperContainer = this.$element.find('.swiper-container');
	}

	getOptions() {
		let keyboard = true;
		let effect = 'slide'; 
		let autoplay = false; 
		let speed = 500;
		let lazyload = this.$swiperContainer.find('.swiper-lazy').length ? true : false;
		let lazy = lazyload ? {
			loadPrevNext: lazyload,
			loadPrevNextAmount: 2,
		} : false;

		let navigation = {
			prevEl: this.$element.find('.button--prev')[0],
			nextEl: this.$element.find('.button--next')[0]
		}

		let $sliderName = this.$element.attr('data-slider');
		let $slider = this.$element;

		let pagination = {
			el: this.$element.find('.slider-pagination'),
			clickable: true,
			renderBullet: function (index, className) {
				if ($sliderName == 'awards') {
					var year = $slider.find('.slider-slide[data-slide-number='+index+']').attr('data-year');
					return '<button type="button" class="' + className + '">' + year+'</button>';
				} else {
					return '<button type="button" class="' + className + '"></button>';
				}
			},
			bulletClass: 'slider-pagination-item',
			bulletActiveClass: 'is-active',
			modifierClass: 'slider-pagination-',
			clickableClass: 'is-clickable'
		}

		let options = {
			keyboard: keyboard,
			effect: effect,
			loop: true,
			speed: speed,
			autoplay: autoplay,
			preloadImages: !lazyload,
			lazy,
			navigation : navigation,
			pagination: pagination
		};	

		if (this.$element.data('slider') == 'awards') {
			if (window.matchMedia('(max-width: 767px)').matches) {
				options.loop = false;
			}
		}

		if (this.$element.data('slider') == 'categories') {

			options.slidesPerView = 'auto';
			options.direction = 'vertical';
			options.centeredSlides = true;
			options.setWrapperSize = true;
			options.height = window.innerHeight;
			options.initialSlide = 2;
			options.loop = false;
			options.virtualTranslate = true;
			options.speed = 300;
			options.simulateTouch = false;

			if (window.matchMedia('(max-width: 767px)').matches) {
				let active = this.$element.find('.active').parents('.slider-slide').index();

				options.slidesPerView = 3;
				options.direction = 'horizontal';
				options.height = undefined;
				options.width = window.innerWidth;
				options.virtualTranslate = false;
				options.simulateTouch = true;
				options.slideToClickedSlide = true;
				options.initialSlide = active > 0 ? active : 0;
			}
		}

		if (this.$element.data('slider') == 'home') {
			if (!window.matchMedia('(max-width: 767px)').matches) {
				options.speed = 0;
				options.effect = 'fade';
				options.autoplay = {
					delay: 7000
				};
			}
		}

		return options;
	}

	createSlider() {
		let options = this.getOptions();

		this.swiper = new Swiper(this.$swiperContainer[0], options);

		if (this.$element.data('slider') == 'categories') {
			if (this.swiper.slides.length <= 5) {
				this.$element.addClass('no-navigation');
				this.$element.addClass('swiper-length-' + this.swiper.slides.length);
				if (window.matchMedia('(max-width: 767px)').matches) {
				} else {
					let moveUp = (55 - this.swiper.slides.length*11)/2;
					this.$element.find('.swiper-wrapper').css('transform', 'translateY(' + moveUp + 'rem)');
				}
			} else {
				if (window.matchMedia('(max-width: 767px)').matches) {
				} else {
					let move = -this.swiper.activeIndex * 11 + 22;
					this.$element.find('.swiper-wrapper').css('transform', 'translateY(' + move + 'rem)');
				}
				this.updatePrevNext();
			}
		}

		this.$element.data('swiperInstance', this.swiper);
		this.$element.trigger('sliderInitialized', this.swiper);
	}

	bind() {

		let currentIndex = this.$element.find('.swiper-slide-active').data('slide-number');
		let timeout;

		if (this.$element.data('slider') == 'home') {
			if (window.matchMedia('(max-width: 767px)').matches) {
				this.$element.find('.swiper-slide .product-details').addClass('animate-in');
			} else {
				this.$element.find('.swiper-slide-active .product-details').addClass('animate-in');
			}
		}

		this.on('slideChange', this.swiper, () => {
			
			let timeoutTime = 1250;
			if (window.matchMedia('(max-width: 767px)').matches) {
				timeoutTime = 1000;
			}

			if (this.$element.data('slider') == 'home' && !window.matchMedia('(max-width: 767px)').matches) {
				if (timeout) {
					clearTimeout(timeout);
				}

				this.$element.find('.swiper-slide .animate-in')
					.removeClass('animate-in')
					.addClass('animate-out');
				
				timeout = setTimeout(() => {
					timeout = null;
					this.$element.find('.swiper-slide-active .product-details')
						.removeClass('animate-out')
						.addClass('animate-in');
					
					currentIndex = this.$element.find('.swiper-slide-active').attr('data-slide-number');
				}, timeoutTime);
			}
		});

		this.on('slideNextTransitionStart', this.swiper, () => {
			if (this.$element.data('slider') == 'categories' && this.swiper.slides.length > 5) {
				if (window.matchMedia('(max-width: 767px)').matches) {
				} else {
					let move = -this.swiper.activeIndex * 11 + 22;
					this.$element.find('.swiper-wrapper').css('transform', 'translateY(' + move + 'rem)');
				}
			}
		});

		this.on('slidePrevTransitionStart', this.swiper, () => {
			if (this.$element.data('slider') == 'categories' && this.swiper.slides.length > 5) {
				if (window.matchMedia('(max-width: 767px)').matches) {
				} else {
					let move = -this.swiper.activeIndex * 11 + 22;
					this.$element.find('.swiper-wrapper').css('transform', 'translateY(' + move + 'rem)');
				}
			}
		});
		
		this.on('setTransition', this.swiper, (duration) => {
			if (window.matchMedia('(max-width: 767px)').matches) {
				if (this.$element.data('slider') == 'categories') {
					this.$element.find('.swiper-slide').css('transition-duration', `${duration}ms`);
				}
			} else {
				if (this.$element.data('slider') == 'categories' && this.swiper.slides.length > 5) {
					this.$element.find('.swiper-slide').css('transition-duration', `${duration}ms`);
				}
			}
		});
		
		this.on('setTranslate', this.swiper, (translate) => {
			if (this.$element.data('slider') == 'categories') {
				if (window.matchMedia('(max-width: 767px)').matches) {
					const progress = translate / Math.max(this.swiper.$el.outerWidth(), (this.swiper.$wrapperEl.outerWidth() - this.swiper.$el.outerWidth()));
					const count = Math.max(this.swiper.slides.length - 3, 3);
					const current = count * progress;
	
					this.$element.find('.swiper-slide').each((index, slide) => {
						const slideTranslate = Math.abs(Math.sin(Math.PI*(index + current - 1) / 10) * 5 * 1.5);
						$(slide).css('y', `${slideTranslate}vw`);
					});
				}
			}
		});
		
		this.on('slideChange', this.swiper, () => {
			setTimeout(() => {
				this.updateBeforeAfterClasses();
			});

			this.updatePrevNext();
		});
		
		this.on('slideNextTransitionStart', this.swiper, () => {
			setTimeout(() => {
				this.$element.find('.slider-pagination').attr('data-dir', -1);
			});
		});
		
		this.on('slidePrevTransitionStart', this.swiper, () => {
			setTimeout(() => {
				this.$element.find('.slider-pagination').attr('data-dir', 1);
			});
		});

		this.on('domready load ajaxload pageIn pageInEnd imageload', this.dom.$window, (e) => {
			if (this.swiper) {
				this.swiper.update();
			}
		});

		this.on('imageload', 'img', (e) => {
			if (this.swiper) {
				this.swiper.update();
			}
		});
		
		this.on('visibilitychanged', (e) => {
			if (this.swiper) {
				this.swiper.update();
			}
		});
	}

	updatePrevNext() {
		
		if (window.matchMedia('(max-width: 767px)').matches) {

		} else {
			if (this.$element.data('slider') == 'categories' && this.swiper.slides.length > 5) {
				if (this.swiper.activeIndex <= 2) {
					this.swiper.allowSlidePrev = true;
					this.$element.find('.button--prev').hide();
				} else {
					this.swiper.allowSlidePrev = true;
					this.$element.find('.button--prev').show();
				}
		
				if (this.swiper.activeIndex + 3 >= this.swiper.slides.length) {
					this.swiper.allowSlideNext = false;
					this.$element.find('.button--next').hide();
				} else {
					this.swiper.allowSlideNext = true;
					this.$element.find('.button--next').show();
				}
			}
		}
	}

	updateBeforeAfterClasses() {
		this.$element.find('.swiper-slide-before-prev').removeClass('swiper-slide-before-prev');
		this.$element.find('.swiper-slide-after-next').removeClass('swiper-slide-after-next');
		this.$element.find('.swiper-slide-prev').prev().addClass('swiper-slide-before-prev');
		this.$element.find('.swiper-slide-next').next().addClass('swiper-slide-after-next');

		this.$element.find('.slider-pagination-item.before-active').removeClass('before-active');
		this.$element.find('.slider-pagination-item.after-active').removeClass('after-active');
		this.$element.find('.slider-pagination-item.is-active').prev().addClass('before-active');
		this.$element.find('.slider-pagination-item.is-active').next().addClass('after-active');
	}

	destroy() {
		super.destroy();

		if (this.slider) {
			this.swiper.destroy();
		}
	}
}

owd.registerComponent('slider', {
	component: Slider
});
